const getDefaultState = () => {
  return {
    billings: [],
    billing: null,
    filters: {},
    loading: false,
    currentUser: null,
    installments: [],
    consumer_units: [],
    consumer_unit: null,
    charge_type: "billing",
    consumer_unit_form_type: "manual",
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};
